'use strict'

// The condition keys are the watchdog's actual producers, including delegated
// memory/launch checks. One preference per condition; never infer from severity.
const WATCHDOG_CONDITIONS = Object.freeze({
  auth: ['watchdogAuth', 'Authentication or billing failure'],
  presence: ['watchdogPresence', 'Heartbeat is stale'],
  reseed: ['watchdogReseed', 'OAuth grant expired'],
  down: ['watchdogDown', 'Agent session is down'],
  'grant-age': ['watchdogGrantAge', 'OAuth grant expires soon'],
  'grant-age-urgent': ['watchdogGrantAgeUrgent', 'OAuth grant expiry is urgent'],
  'launch-refused': ['watchdogLaunchRefused', 'Agent launch was refused'],
  'session-unresolved': ['watchdogSessionUnresolved', 'Current session cannot be identified'],
  reload: ['watchdogReload', 'Identity was not reloaded after compaction'],
  memory: ['watchdogMemory', 'Short-term memory is not saving'],
  'memory-shrank': ['watchdogMemoryShrank', 'Memory content shrank unexpectedly'],
  'memory-size': ['watchdogMemorySize', 'Short-term memory is over budget'],
  'memory-blocked': ['watchdogMemoryBlocked', 'Memory startup is blocked'],
  'memory-mount': ['watchdogMemoryMount', 'Memory mount differs from its plan'],
  'memory-degraded': ['watchdogMemoryDegraded', 'Agent started without memory tools'],
  'memory-recall': ['watchdogMemoryRecall', 'Memory recall is missing or failing'],
  'memory-instruction-echo': [
    'watchdogMemoryInstructionEcho',
    'Agent repeated an instruction from memory',
  ],
  'memory-undone': ['watchdogMemoryUndone', 'Memory upkeep undid part of itself'],
  'memory-pass': ['watchdogMemoryPass', 'Memory pass was not marked complete'],
  'memory-maintenance': ['watchdogMemoryMaintenance', 'Maintenance window ended incomplete'],
  'capsule-integrity': ['watchdogCapsuleIntegrity', 'Trusted memory core is damaged'],
  'capsule-core-pressure': [
    'watchdogCapsuleCorePressure',
    'Resident memory core is near its limit',
  ],
  'curation-gate-denied': ['watchdogCurationGateDenied', 'Memory curation was denied'],
})
const SUPERADMIN_EVENTS = Object.freeze([
  ...Object.values(WATCHDOG_CONDITIONS).map(([kind]) => kind),
  'phoneSystemHealth',
  'systemMonitoring',
])
const IDEMPOTENT_EVENTS = Object.freeze([
  ...SUPERADMIN_EVENTS,
  'mretsAutomation',
  'mretsRunSummary',
  'siteMonitoringMeterSwitch',
  'mretsLedgerDivergence',
])
function isOperationalSuperAdmin(user) {
  const raw = user?.roles?.userRole
  const roles = (Array.isArray(raw) ? raw : [raw]).map(role => String(role).toLowerCase())
  return (
    user?.roles?.isSuperAdmin === true &&
    user?.status?.accountStatus === 'active' &&
    !user?.linkedCustomerId &&
    !roles.some(role => ['customer', 'marketing_reviewer'].includes(role)) &&
    !['suspended', 'deleted', 'disabled', 'directory', 'inactive'].includes(
      user?.status?.accountStatus
    )
  )
}
const eventVisible = (kind, isSuperAdmin) =>
  !SUPERADMIN_EVENTS.includes(kind) || isSuperAdmin === true
module.exports = {
  WATCHDOG_CONDITIONS,
  SUPERADMIN_EVENTS,
  IDEMPOTENT_EVENTS,
  isOperationalSuperAdmin,
  eventVisible,
}
